import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestOutcomeResultPipe } from './request-outcome-result.pipe';
import { RequestOutcomeIconClassPipe } from './request-outcome-icon-class.pipe';

@NgModule({
  declarations: [RequestOutcomeResultPipe, RequestOutcomeIconClassPipe],
  imports: [CommonModule],
  exports: [RequestOutcomeResultPipe, RequestOutcomeIconClassPipe],
})
export class ConferencesPipesModule {}
